import {AnalysisStatusEnum} from "../models/analysis-status";

export class PatchCBDRequestDto {
  constructor(public cbdId: number,
              public status: AnalysisStatusEnum,
              public originalWidth: number,
              public originalHeight: number,
              ) {}
}
